exports.intervals = {
  'hourly': 'Hourly',
  'daily': 'Daily',
  'weekly': 'Weekly',
  'monthly': 'Monthly',
  'yearly': 'Yearly'
}

exports.types = {
  'errorsReport': 'Error report',
  'statisticsReport': 'Statistics report'
}



// WEBPACK FOOTER //
// ./js/modules/client-mailreports/reportConstants.js